import React from 'react';

export default function ArticleAudioButtonPlay() {
  return (
    <svg style={{ marginLeft: '5px' }} width="18px" height="21px" viewBox="0 0 18 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="03_Articles" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1440_Article_Audio_01" transform="translate(-464.000000, -939.000000)" fill="#003A1B">
          <g id="Group-19" transform="translate(400.000000, 879.000000)">
            <g id="Group-11" transform="translate(40.000000, 40.000000)">
              <g id="Group-6">
                <polygon id="Path-3" points="24 20 24 41 41.5820312 30.5"></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
